import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

const descriptionDefaults = {
  position: 'absolute',
  top: 50,
  marginLeft: -30,
  width: 100,
  textAlign: 'center',
  color: colour.grey[200],
  fontWeight: 600,
  fontSize: 14
}

export const styles = StyleSheet.create({
  stepperWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    marginTop: 25,
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 80,
    ':before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: 1,
      borderBottom: `1px solid ${colour.grey[500]}`,
      position: 'absolute',
      zIndex: -1
    }
  },
  step: {
    color: colour.grey[400],
    background: '#ffffff',
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: '50%',
    padding: '4px 12px 5px',
    fontSize: 20,
    fontWeight: 700
  },
  active: {
    color: '#ffffff',
    background: colour.brand.blue,
    border: `1px solid ${colour.brand.blue}`,
  },
  descriptionMain: {
    ...descriptionDefaults,
    ':before': {
      content: "url('/icons/HomeIcon.svg')",
      position: 'absolute',
      width: 20,
      top: -20,
      left: 'calc(50% - 10px)'
    }
  },
  descriptionAssisted: {
    ...descriptionDefaults,
    ':before': {
      content: "url('/icons/ParentsHomeIcon.svg')",
      position: 'absolute',
      width: 20,
      top: -20,
      left: 'calc(50% - 10px)'
    }
  }
});
